"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpansionPanelSummary = exports.ExpansionPanelDetails = exports.ExpansionPanelActions = exports.ExpansionPanel = void 0;
var Accordion_1 = require("../Accordion");
var AccordionActions_1 = require("../AccordionActions");
var AccordionDetails_1 = require("../AccordionDetails");
var AccordionSummary_1 = require("../AccordionSummary");
/** @deprecated ExpansionPanel renamed to Accordion; import directly from beam/dist/Accordion */
exports.ExpansionPanel = Accordion_1.Accordion;
exports.default = exports.ExpansionPanel;
/** @deprecated ExpansionPanelActions renamed to AccordionActions; import directly from beam/dist/AccordionActions */
exports.ExpansionPanelActions = AccordionActions_1.AccordionActions;
/** @deprecated ExpansionPanelDetails renamed to AccordionDetails; import directly from beam/dist/AccordionDetails */
exports.ExpansionPanelDetails = AccordionDetails_1.AccordionDetails;
/** @deprecated ExpansionPanelSummary renamed to AccordionSummary; import directly from beam/dist/AccordionSummary */
exports.ExpansionPanelSummary = AccordionSummary_1.AccordionSummary;
//# sourceMappingURL=index.js.map